import script from "./ViewWarrantPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewWarrantPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewWarrantPage.vue?vue&type=style&index=0&id=63d5d8d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d5d8d8"]])

export default __exports__